var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDrawLot = function SvgDrawLot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 6.95l.727-2.544a.7.7 0 011.346 0L9.4 6.95V8h.503a.7.7 0 01.68.53l.953 3.813a5.6 5.6 0 10-7.071 0l.952-3.813a.7.7 0 01.68-.53H6.6V6.95zM8 13.6a5.567 5.567 0 002.285-.486L9.357 9.4H6.643l-.928 3.714A5.565 5.565 0 008 13.6zM8 15A7 7 0 118 1a7 7 0 010 14z",
    fill: "#666"
  })));
};
export default SvgDrawLot;